import React from 'react';
import ChooseDeliveryPersonLinks from '../../Buttons/ChooseDeliveryPersonLinks/ChooseDeliveryPersonLinks';
import {useStyles} from "./ShowDeliveryPerson.style";
import ShowDeliveryPersonProperties from "./ShowDeliveryPersonProperties";
import AllowAccess from "../../../shared_components/Access/AllowAccess/AllowAccess";
import Access from "../../../shared_components/Access/AllowAccess/Access";
import { useUserContext } from '../../../contexts/UserContext';

const ShowDeliveryPerson: React.FC<ShowDeliveryPersonProperties> = ({
                                                          text,
                                                          showActionLinks = true,
                                                          orderByGeosIdProximity = [],
                                                          className = '',
                                                          service,
                                                          onClick = () => {
                                                          },
                                                          onSelect = () => {
                                                          }
                                                      }) => {
    const classes = useStyles();
    const userStore = useUserContext();
    const showDeliveryPersonName = userStore.hasAccess(Access.DISPLAY_DELIVERY_PERSON_IN_ORDERS);

    if (!userStore.isRootAgency() && !showDeliveryPersonName) {
        return <></>;
    }


    return (
        <div className={className}>
            <>
                {<div className={classes.title}>{`Repartidor:`}</div>}
                <div>{text ? text : '-'}</div>
                {showActionLinks && <AllowAccess any={[Access.SET_MONEY_DELIVERY_DELIVERY_PERSON]}>
                    <ChooseDeliveryPersonLinks
                        haveDeliveryPersonSelected={text != null}
                        orderByGeosIdProximity={orderByGeosIdProximity}
                        service={service}
                        onClick={onClick}
                        onSelect={onSelect}>
                    </ChooseDeliveryPersonLinks>
                </AllowAccess>}
            </>
        </div>
    )
}
export default ShowDeliveryPerson;